import React from "react";

function CarePlanTasksTable({ data }) {
  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "w-full"
          } rounded-lg flex justify-center`}
        >
          <table className="w-full overflow-scroll relative ">
            <thead className="border rounded-lg">
              <tr>
                <th>Task Name</th>
                <th>Frequency</th>
                <th>From Date</th>
                <th>To Date</th>
              </tr>
              {/* <tr className="bg-[#DEF3F2]">
                <td className="py-0.5" colSpan={4}></td>
              </tr> */}
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={item.key || idx}>
                  <tr className="border-b">
                    <td>
                      {item.taskName?.trim() ? item.taskName : item.taskCode}
                    </td>
                    <td>{item.frequencyDescription}</td>
                    <td>{item.fromDate}</td>
                    <td>{item.toDate}</td>
                  </tr>
                  {/* <tr className="bg-[#DEF3F2]">
                    <td className="py-0.5" colSpan={4}></td>
                  </tr> */}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default CarePlanTasksTable;
